export default "__VITE_ASSET__BtV5PiCG__"